export enum RequestTypes {
  ORGANISER = 0,
  PUBLISH_EVENT = 1,
  ADD_EVENT_TO_LEAGUE = 2
}
